const Desc = `smartObjectV2: same instance, aws. ${new Error('To get file path').stack.split('\n')[1].match(/Object(.+)\(https/)[1] || ''}`

const Payload = {
    inputs: [
        {
            href: 'files/_skycity_smoketest/4so.psd',
            storage: 'adobe'
        }
    ],
    options: {
        layers: [
            {
                id: 2,
                input: {
                    href: 'https://as2.ftcdn.net/jpg/02/16/53/79/500_F_216537946_ODYbV4mHvMYtcpS6zUQ1nilKBkHnaazp.jpg',
                    storage: 'external'
                }
            }
        ]
    },
    outputs: [
        {
            storage: 'adobe',
            type: 'image/jpeg',
            overwrite: true,
            width: 0,
            quality: 7
        }
    ]
}

module.exports = { Payload, Desc }
